import { useEffect, useRef } from 'react';
import { useMap, Marker, Popup } from 'react-leaflet';
import { CATEGORIES } from '../constants';
import { createPin } from '../utils';
import PopupContent from './PopupContent';

export default function MapClickHandler({ pins, userPosition, targetPostId, currentUser, followingIds, onUserClick }) {
  const map = useMap();
  const markerRefs = useRef({});
  const openedRef = useRef(false);

  useEffect(() => {
    if (targetPostId && pins.length > 0 && !openedRef.current) {
      const target = pins.find(p => p.id === targetPostId);
      if (target) {
        openedRef.current = true;
        map.setView([target.lat, target.lng], 17, { animate: false });
        const tryOpen = (attempts) => {
          if (attempts <= 0) return;
          const markerRef = markerRefs.current[targetPostId];
          if (markerRef) {
            markerRef.openPopup();
          } else {
            setTimeout(() => tryOpen(attempts - 1), 500);
          }
        };
        setTimeout(() => tryOpen(10), 500);
      }
    }
  }, [targetPostId, pins, map]);

  return (
    <>
      {pins.map(pin => (
        <Marker
          key={pin.id}
          position={[pin.lat, pin.lng]}
          icon={createPin(CATEGORIES[pin.category]?.color || '#95A5A6', CATEGORIES[pin.category]?.emoji || '💬')}
          ref={el => { if (el) markerRefs.current[pin.id] = el; }}
          eventHandlers={{
            popupopen: (e) => {
              const px = map.project(e.popup.getLatLng());
              px.y -= 500;
              map.panTo(map.unproject(px), { animate: true });
            },
          }}
        >
          <Popup>
            <PopupContent pin={pin} userPosition={userPosition} onUserClick={onUserClick} currentUser={currentUser} />
          </Popup>
        </Marker>
      ))}
    </>
  );
}